import ManagedLookup from '../components/ManagedLookup';
import useLicensingPage from '../hooks/useLicensingPage';
import fields from './fields';
import columns from './columns';

const StateLicenseRequirements = ({ definition }) => {
    const page = useLicensingPage('state-license-requirements', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};

export default StateLicenseRequirements;
